export enum UpdateCaducityNames {
    CADUCITY = "caducity",
}
export interface UpdateCaducityState {
    [UpdateCaducityNames.CADUCITY]: number;
}
